export const resolveDatabaseTimeframe = (database, timePeriod) => {
  if (String(database).toLowerCase() !== "ebsco" || !timePeriod) {
    return { timePeriod, note: null, severity: "info" };
  }
  if (timePeriod === "Day" || timePeriod === "Week") {
    return {
      timePeriod: "Month",
      note: "EBSCO doesn’t support Past Day or Past Week. Showing Past Month results instead.",
      severity: "warning",
    };
  }
  return {
    timePeriod,
    note: null,
    severity: "info",
  };
};
